var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { styleUtilities } from "@/constants/global";
import { prettyScroll } from "@/helpers/dom";
export default class StickyNav {
    constructor() {
        var _a;
        this.stickyNavTop = 0;
        this.$stickyNav = undefined;
        this.$stickyNavWrapper = undefined;
        this.$contentWrapper = undefined;
        this.$header = undefined;
        this.$helloBar = undefined;
        this.instance = undefined;
        this.tabClass = "c-tabs_tab";
        this.activeTabClass = "c-tabs_tab--active";
        this.splide = undefined;
        this.activeSlide = 0;
        this.isSplideDestroyed = true;
        this.SplideClass = null;
        this.mountSplide = () => {
            var _a, _b, _c, _d, _e, _f;
            if ((!this.instance || this.isSplideDestroyed) && this.SplideClass) {
                this.instance = new this.SplideClass(this.splide[0], {
                    type: "slide",
                    speed: 1000,
                    perPage: 3,
                    perMove: 1,
                    start: this.activeSlide,
                    focus: "center",
                    pagination: false,
                    gap: "0",
                    autoplay: false,
                    lazyLoad: false,
                    trimSpace: false,
                    role: "group",
                    mediaQuery: "min",
                    breakpoints: {
                        768: {
                            destroy: true,
                        },
                    },
                });
                (_a = this.instance) === null || _a === void 0 ? void 0 : _a.on("mount", () => {
                    this.isSplideDestroyed = false;
                });
                (_b = this.instance) === null || _b === void 0 ? void 0 : _b.on("mounted", () => {
                    this.isSplideDestroyed = false;
                    this.instance.go(this.activeSlide);
                });
                (_c = this.instance) === null || _c === void 0 ? void 0 : _c.on("active", () => {
                    this.isSplideDestroyed = false;
                });
                (_d = this.instance) === null || _d === void 0 ? void 0 : _d.on("moved", () => {
                    var _a;
                    this.activeSlide = (_a = this.instance) === null || _a === void 0 ? void 0 : _a.index;
                });
                (_e = this.instance) === null || _e === void 0 ? void 0 : _e.on("destroy", () => {
                    var _a;
                    this.activeSlide = (_a = this.instance) === null || _a === void 0 ? void 0 : _a.index;
                    this.isSplideDestroyed = true;
                    this.addTabListener();
                });
                (_f = this.instance) === null || _f === void 0 ? void 0 : _f.mount();
            }
        };
        this.applyEventListeners = () => {
            this.$stickyNav.find("a").on("click", () => {
                event.preventDefault();
                const $anchor = $(event.currentTarget);
                const $target = $($anchor.attr("href"));
                const headerHeight = this.$header.outerHeight(true);
                const stickyNavHeight = this.$stickyNav.outerHeight(true);
                const stickyNavOffset = $target.offset().top;
                let offsetTop = stickyNavOffset - (headerHeight + stickyNavHeight);
                const isSticky = this.$stickyNav.hasClass("c-sticky-nav--stick");
                if (!isSticky) {
                    offsetTop -= stickyNavHeight;
                }
                if (this.$helloBar.length && this.$helloBar.is(":visible")) {
                    offsetTop -= this.$helloBar.outerHeight(true);
                }
                if (offsetTop < 0) {
                    offsetTop = 0;
                }
                prettyScroll(0, offsetTop);
                this.activateAdditionalFunctionality($target);
            });
        };
        this.adjustPosition = () => {
            var _a, _b, _c, _d, _e, _f;
            this.stickyNavTop = this.$stickyNavWrapper.offset().top;
            let scrollTop = $(window).scrollTop();
            let topOffset = 0;
            const isNavFirstEl = this.$contentWrapper.children(":first").attr("id") ===
                this.$stickyNavWrapper.attr("id");
            const shouldPadMainContent = isNavFirstEl && this.$helloBar.length && this.$helloBar.is(":visible");
            this.$contentWrapper.toggleClass("u-pt-10", shouldPadMainContent);
            if (this.$helloBar.length && this.$helloBar.is(":visible")) {
                const helloBarHeight = this.$helloBar.outerHeight(true);
                scrollTop += helloBarHeight;
                topOffset += helloBarHeight;
            }
            if (this.$header.length) {
                const headerHeight = this.$header.outerHeight(true);
                scrollTop += headerHeight;
                topOffset += headerHeight;
            }
            if (scrollTop > this.stickyNavTop) {
                this.$stickyNav.addClass("c-sticky-nav--stick");
                this.$stickyNav.css("top", `${topOffset - 1}px`);
                (_b = (_a = this.splide) === null || _a === void 0 ? void 0 : _a.find(".splide__arrows")) === null || _b === void 0 ? void 0 : _b.removeClass(styleUtilities.hidden);
                this.mountSplide();
            }
            else {
                (_d = (_c = this.splide) === null || _c === void 0 ? void 0 : _c.find(".splide__arrows")) === null || _d === void 0 ? void 0 : _d.addClass(styleUtilities.hidden);
                this.activeSlide = (_e = this.instance) === null || _e === void 0 ? void 0 : _e.index;
                (_f = this.instance) === null || _f === void 0 ? void 0 : _f.destroy(true);
                this.addTabListener();
                this.$stickyNav.removeClass("c-sticky-nav--stick");
                this.$stickyNav.css("top", "");
            }
        };
        this.activateAdditionalFunctionality = ($target) => {
            if ($target.hasClass("js-filtered-library-block-wrapper")) {
                const $block = $target.find(".js-filtered-library-block");
                if ($block.is(":hidden")) {
                    const $accordionButton = $target.find(".js-toggle");
                    $accordionButton.trigger("click");
                }
            }
        };
        this.addTabListener = () => {
            var _a, _b;
            (_b = (_a = this.$stickyNav) === null || _a === void 0 ? void 0 : _a.find(`.${this.tabClass}`)) === null || _b === void 0 ? void 0 : _b.each((index, tab) => {
                tab.addEventListener("click", () => {
                    var _a;
                    this.activeSlide = index;
                    (_a = this.$stickyNav) === null || _a === void 0 ? void 0 : _a.find(`.${this.activeTabClass}`).removeClass(this.activeTabClass);
                    tab.classList.add(this.activeTabClass);
                });
            });
        };
        this.adjustPosition = this.adjustPosition.bind(this);
        this.applyEventListeners = this.applyEventListeners.bind(this);
        this.loadSplide = this.loadSplide.bind(this);
        this.$stickyNav = $("#js-sticky-nav");
        this.$stickyNavWrapper = $("#js-sticky-nav-wrapper");
        this.$contentWrapper = this.$stickyNavWrapper.parent();
        this.$helloBar = $(".c-hello-bar");
        this.$header = $("#header");
        this.splide = (_a = this.$stickyNav) === null || _a === void 0 ? void 0 : _a.find(".splide");
        this.loadSplide();
        this.applyEventListeners();
        this.adjustPosition();
        $(window).scroll(() => {
            this.adjustPosition();
        });
    }
    loadSplide() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const SplideModule = yield import("@splidejs/splide");
                this.SplideClass = SplideModule.default || SplideModule.Splide;
                console.log("✅ Splide loaded dynamically for StickyNav");
                this.mountSplide();
            }
            catch (error) {
                console.error("❌ Failed to load Splide:", error);
            }
        });
    }
    static init() {
        if ($("#js-sticky-nav").length) {
            const stickyNav = new StickyNav();
            return stickyNav;
        }
        else {
            return null;
        }
    }
}
